import { YouWillMakeComponent } from './you-will-make';
export const YouWillMake = YouWillMakeComponent;